export const FETCH_PROMPTS_REQUEST = 'FETCH_PROMPTS_REQUEST';
export const FETCH_PROMPTS_SUCCESS = 'FETCH_PROMPTS_SUCCESS';
export const FETCH_PROMPTS_FAILURE = 'FETCH_PROMPTS_FAILURE';

export const CREATE_PROMPT_REQUEST = 'CREATE_PROMPT_REQUEST';
export const CREATE_PROMPT_SUCCESS = 'CREATE_PROMPT_SUCCESS';
export const CREATE_PROMPT_FAILURE = 'CREATE_PROMPT_FAILURE';

export const UPDATE_PROMPT_REQUEST = 'UPDATE_PROMPT_REQUEST';
export const UPDATE_PROMPT_SUCCESS = 'UPDATE_PROMPT_SUCCESS';
export const UPDATE_PROMPT_FAILURE = 'UPDATE_PROMPT_FAILURE';

export const DELETE_PROMPT_REQUEST = 'DELETE_PROMPT_REQUEST';
export const DELETE_PROMPT_SUCCESS = 'DELETE_PROMPT_SUCCESS';
export const DELETE_PROMPT_FAILURE = 'DELETE_PROMPT_FAILURE';

export const UPDATE_PROMPT_VERSION_STATUS_REQUEST = 'UPDATE_PROMPT_VERSION_STATUS_REQUEST';
export const UPDATE_PROMPT_VERSION_STATUS_SUCCESS = 'UPDATE_PROMPT_VERSION_STATUS_SUCCESS';
export const UPDATE_PROMPT_VERSION_STATUS_FAILURE = 'UPDATE_PROMPT_VERSION_STATUS_FAILURE';

export const FETCH_PROMPTS_BY_AGENT_REQUEST = 'FETCH_PROMPTS_BY_AGENT_REQUEST';
export const FETCH_PROMPTS_BY_AGENT_SUCCESS = 'FETCH_PROMPTS_BY_AGENT_SUCCESS';
export const FETCH_PROMPTS_BY_AGENT_FAILURE = 'FETCH_PROMPTS_BY_AGENT_FAILURE';

// Action Creators for Fetching Prompts
export const fetchPromptsRequest = ({ page = 1, limit = 10, search = '', agentId } = {}) => ({
  type: FETCH_PROMPTS_REQUEST,
  payload: { page, limit, search, agentId },
});

export const fetchPromptsSuccess = (data) => ({
  type: FETCH_PROMPTS_SUCCESS,
  payload: data,
});

export const fetchPromptsFailure = (error) => ({
  type: FETCH_PROMPTS_FAILURE,
  payload: error,
});

// Action Creators for Creating Prompts
export const createPromptRequest = ({ data, meta }) => ({
  type: CREATE_PROMPT_REQUEST,
  payload: { data, meta },
});

export const createPromptSuccess = (data) => ({
  type: CREATE_PROMPT_SUCCESS,
  payload: data,
});

export const createPromptFailure = (error) => ({
  type: CREATE_PROMPT_FAILURE,
  payload: error,
});

// Action Creators for Updating Prompts
export const updatePromptRequest = (promptId, promptData, meta) => ({
  type: UPDATE_PROMPT_REQUEST,
  payload: { promptId, promptData, meta },
});

export const updatePromptSuccess = (data) => ({
  type: UPDATE_PROMPT_SUCCESS,
  payload: data,
});

export const updatePromptFailure = (error) => ({
  type: UPDATE_PROMPT_FAILURE,
  payload: error,
});

// Action Creators for Deleting Prompts
export const deletePromptRequest = ({ promptId, meta }) => ({
  type: DELETE_PROMPT_REQUEST,
  payload: { promptId, meta },
});

export const deletePromptSuccess = (promptId) => ({
  type: DELETE_PROMPT_SUCCESS,
  payload: promptId,
});

export const deletePromptFailure = (error) => ({
  type: DELETE_PROMPT_FAILURE,
  payload: error,
});

// update prompt version status
export const updatePromptVersionStatusRequest =  (data) =>({
  type:UPDATE_PROMPT_VERSION_STATUS_REQUEST,
  payload:data
})

export const updatePromptVersionSuccess = (data) => ({
  type:UPDATE_PROMPT_VERSION_STATUS_SUCCESS,
  payload:data
})

export const updatePromptVersionFailure = (error) => ({
  type:UPDATE_PROMPT_VERSION_STATUS_FAILURE,
  payload:error
})

// Action Creators for Fetching Prompts by Agent ID
export const fetchPromptsByAgentRequest = (agentId, model) => ({
  type: "FETCH_PROMPTS_BY_AGENT_REQUEST",
  payload: { agentId,model },
});


export const fetchPromptsByAgentSuccess = (data) => ({
  type: FETCH_PROMPTS_BY_AGENT_SUCCESS,
  payload: data,
});

export const fetchPromptsByAgentFailure = (error) => ({
  type: FETCH_PROMPTS_BY_AGENT_FAILURE,
  payload: error,
});
